export default {
  setLoggedIn(state, status) {
    state.isLoggedIn = status;
  } ,
  
  LOGOUT_USER(state) {
    state.token = null;
    state.isLoggedIn = false;
    state.userId = null;
  
  }
};